import React, { useState } from "react";
import "../styles.css";
import {
  crearVehiculo,
  crearMaquinaria,
  crearUtillaje,
  actualizarVehiculo,
  actualizarMaquinaria,
  actualizarUtillaje,
} from "../api";
import { toast } from "react-toastify";

function ModalCrearEquipo({ onClose, equipo, tipoPorDefecto }) {
  const [tipoObjeto, setTipoObjeto] = useState(
    equipo?.tipoObjeto || tipoPorDefecto || "vehiculo"
  );
  const [nombre, setNombre] = useState(equipo?.nombre || "");
  const [matricula, setMatricula] = useState(equipo?.matricula || "");
  const [referenciaInterna, setReferenciaInterna] = useState(
    equipo?.referencia_interna || equipo?.referencia || ""
  );
  const [tipo, setTipo] = useState(equipo?.tipo || "");
  const [fechaITV, setFechaITV] = useState(
    equipo?.itv_fecha ? equipo.itv_fecha.split("T")[0] : ""
  );
  const [fechaProximaITV, setFechaProximaITV] = useState(
    equipo?.fecha_proxima_itv ? equipo.fecha_proxima_itv.split("T")[0] : ""
  );
  const [kmActual, setKmActual] = useState(equipo?.km_actual ?? "");
  const [kmUltimoMantenimiento, setKmUltimoMantenimiento] = useState(
    equipo?.km_ultimo_mantenimiento ?? ""
  );
  const [horasActuales, setHorasActuales] = useState(
    equipo?.horas_actuales ?? ""
  );
  const [horasUltimoMantenimiento, setHorasUltimoMantenimiento] = useState(
    equipo?.horas_ultimo_mantenimiento ?? ""
  );

  const [imagen, setImagen] = useState(equipo?.imagen || "");

  const safeNumber = (val) => (val !== "" ? Number(val) : null);

  const handleGuardar = async () => {
    if (!nombre || !matricula || !tipo) {
      toast.warning("Los campos Nombre, Matrícula/SN y Tipo son obligatorios.");
      return;
    }

    try {
      const payload = {
        nombre,
        matricula,
        tipo,
        referencia_interna: referenciaInterna || "",
        itv_fecha: fechaITV || null,
        fecha_proxima_itv: fechaProximaITV || null,
        imagen: imagen || null,
      };

      if (tipoObjeto === "vehiculo") {
        payload.km_actual = safeNumber(kmActual);
        payload.km_ultimo_mantenimiento = safeNumber(kmUltimoMantenimiento);
      } else if (tipoObjeto === "maquinaria" || tipoObjeto === "utillaje") {
        payload.horas_actuales = safeNumber(horasActuales);
        payload.horas_ultimo_mantenimiento = safeNumber(
          horasUltimoMantenimiento
        );
      }

      let objGuardado;

      if (equipo?.id) {
        switch (tipoObjeto) {
          case "vehiculo":
            objGuardado = await actualizarVehiculo(equipo.id, payload);
            break;
          case "maquinaria":
            objGuardado = await actualizarMaquinaria(equipo.id, payload);
            break;
          case "utillaje":
            objGuardado = await actualizarUtillaje(equipo.id, payload);
            break;
          default:
            throw new Error("Tipo de equipo no válido.");
        }
      } else {
        switch (tipoObjeto) {
          case "vehiculo":
            objGuardado = await crearVehiculo(payload);
            break;
          case "maquinaria":
            objGuardado = await crearMaquinaria(payload);
            break;
          case "utillaje":
            objGuardado = await crearUtillaje(payload);
            break;
          default:
            throw new Error("Tipo de equipo no válido.");
        }
      }

      onClose(objGuardado);
    } catch (err) {
      console.error("Error guardando equipo:", err);
      toast.error("Error al guardar el equipo");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-ancho">
        <button className="modal-close-button" onClick={() => onClose()}>
          ✖
        </button>

        <h2>
          {equipo?.id ? "Editar" : "Crear"}{" "}
          {tipoObjeto.charAt(0).toUpperCase() + tipoObjeto.slice(1)}
        </h2>

        <div className="form-group">
          <label>Tipo de objeto</label>
          <select
            value={tipoObjeto}
            onChange={(e) => setTipoObjeto(e.target.value)}
            disabled={!!equipo || !!tipoPorDefecto}
          >
            <option value="vehiculo">Vehículo</option>
            <option value="maquinaria">Maquinaria</option>
            <option value="utillaje">Utillaje</option>
          </select>
        </div>

        <div className="form-group">
          <label>Nombre</label>
          <input
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Nombre del equipo..."
          />
        </div>

        <div className="form-group">
          <label>Matrícula / SN</label>
          <input
            value={matricula}
            onChange={(e) => setMatricula(e.target.value)}
            placeholder="Matrícula o número de serie..."
          />
        </div>

        <div className="form-group">
          <label>Referencia interna</label>
          <input
            value={referenciaInterna}
            onChange={(e) => setReferenciaInterna(e.target.value)}
            placeholder="Código interno o referencia del equipo..."
          />
        </div>

        <div className="form-group">
          <label>Tipo</label>
          <input
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            placeholder="Tipo o categoría..."
          />
        </div>

        <div className="form-group">
          <label>Ruta Imagen Principal</label>
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
            <input
              value={imagen}
              onChange={(e) => setImagen(e.target.value)}
              placeholder="Ruta de la imagen (ej: uploads/...)"
              style={{ flex: 1 }}
            />
          </div>
          {imagen && (
            <small style={{ color: "#666", fontSize: "0.85em", display: "block", marginTop: "4px" }}>
              * Borra el texto y guarda para eliminar la imagen.
            </small>
          )}
        </div>

        {(tipoObjeto === "vehiculo" || tipoObjeto === "maquinaria") && (
          <>
            <div className="form-group">
              <label>Fecha última ITV</label>
              <input
                type="date"
                value={fechaITV}
                onChange={(e) => setFechaITV(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Fecha próxima ITV</label>
              <input
                type="date"
                value={fechaProximaITV}
                onChange={(e) => setFechaProximaITV(e.target.value)}
              />
            </div>
          </>
        )}

        {tipoObjeto === "vehiculo" && (
          <>
            <div className="form-group">
              <label>Kilómetros actuales</label>
              <input
                type="number"
                min={0}
                value={kmActual}
                onChange={(e) => setKmActual(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Kilómetros último mantenimiento</label>
              <input
                type="number"
                min={0}
                value={kmUltimoMantenimiento}
                onChange={(e) => setKmUltimoMantenimiento(e.target.value)}
              />
            </div>
          </>
        )}

        {(tipoObjeto === "maquinaria" || tipoObjeto === "utillaje") && (
          <>
            <div className="form-group">
              <label>Horas actuales</label>
              <input
                type="number"
                min={0}
                value={horasActuales}
                onChange={(e) => setHorasActuales(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Horas último mantenimiento</label>
              <input
                type="number"
                min={0}
                value={horasUltimoMantenimiento}
                onChange={(e) =>
                  setHorasUltimoMantenimiento(e.target.value)
                }
              />
            </div>
          </>
        )}

        <div className="modal-actions">
          <button className="botonEditar" onClick={handleGuardar}>
            Guardar
          </button>
          <button className="botonAzul" onClick={() => onClose()}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalCrearEquipo;
